import { render, staticRenderFns } from "./salesman-list.vue?vue&type=template&id=18990891&scoped=true&"
import script from "./salesman-list.vue?vue&type=script&lang=js&"
export * from "./salesman-list.vue?vue&type=script&lang=js&"
import style0 from "./salesman-list.vue?vue&type=style&index=0&id=18990891&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18990891",
  null
  
)

export default component.exports